import type {
  SemanticEnumRegistry as SharedSemanticEnumRegistry,
  SemanticEnumTagColor,
  SemanticEnumValueEnumItem,
  SemanticEnumValueEnumRecord,
  SemanticEnumValuePresentation as SharedSemanticEnumValuePresentation,
  SemanticEnumValueStatus,
} from "@airange/shared/semantic-enum";
import type { LegendBadgeStatus, LegendSemantic } from "./semantic-legend";

export {
  buildSemanticEnumValueEnum,
  DEFAULT_TAG_COLOR_BY_TONE,
  DEFAULT_VALUE_ENUM_STATUS_BY_TONE,
  getSemanticEnumLegendSemantic,
  getSemanticEnumPresentation,
  getSemanticEnumTagColor,
  getSemanticEnumValueStatus,
} from "@airange/shared/semantic-enum";

export type {
  SemanticEnumTagColor,
  SemanticEnumValueEnumItem,
  SemanticEnumValueEnumRecord,
  SemanticEnumValueStatus,
};

export type SemanticEnumTone = LegendBadgeStatus;
export type SemanticEnumValuePresentation = SharedSemanticEnumValuePresentation<LegendSemantic>;
export type SemanticEnumRegistry<TValue extends string = string> = SharedSemanticEnumRegistry<TValue, LegendSemantic>;
